import { DEV_HOSTNAME, hostname, PROD_HOSTNAME } from 'core/environments'

export const getManagerCertificationVideoURL = fileName => {
  const environment = hostname === PROD_HOSTNAME ? PROD_HOSTNAME : DEV_HOSTNAME

  return `https://${environment}/sparck-manager-certification-training/${fileName}.mp4`
}
